<script>
  export default {
    name: "AtomImage",
    props: {
      src: { type: String, required: false },
      alt: { type: String, required: true },
      lazy: { type: Boolean, default: true },
      width: { type: [Number, String], default: null },
      height: { type: [Number, String], default: null },
      styles: { type: Object, default: () => ({}) },
    },
  };
</script>

<template>
  <img :src="src" :alt="alt" class="atom-image" :loading="lazy ? 'lazy' : 'eager'" :width="width" :height="height" :style="styles" />
</template>

<style lang="scss">
  .atom-image {
    display: block;
    max-width: 100%;
    height: auto;
  }
</style>
